document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.getElementById('open-fe-account-modal');
  const closeButton = document.getElementById('close-fe-account-modal');
  const cancelButton = document.getElementById('cancel-fe-account-modal');
  const modal = document.getElementById('fe-account-modal');

  if (modal) {
    document.body.appendChild(modal);
  } //z-index fix

  const backdrop = modal?.querySelector('.fe-account-modal__backdrop');
  const form = document.getElementById('fe-account-form');
  const message = document.getElementById('fe-account-message');
  const submitButton = document.getElementById('fe-account-submit');
  const formState = document.getElementById('fe-account-form-state');
  const successState = document.getElementById('fe-account-success');
  const successCloseButton = document.getElementById('close-fe-account-success');

  if (!openButton || !modal || !form) {
    return;
  }

  const endpoint =
    'https://fe-account-integration.merchology.com/fe-create-account'; 

  function openModal() {
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
  }

function closeModal() {
  modal.style.display = 'none';
  modal.setAttribute('aria-hidden', 'true');

  if (message) {
    message.textContent = '';
  }

  const params = new URLSearchParams(window.location.search);

  if (params.get('signup') === 'success') {
    params.delete('signup');

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : '') +
      window.location.hash;

    window.history.replaceState(
      {},
      document.title,
      newUrl
    );
  }
}

  const params = new URLSearchParams(window.location.search);

if (params.get('signup') === 'success') {
  formState.style.display = 'none';
  successState.style.display = 'block';

  modal.style.display = 'flex';
  modal.setAttribute('aria-hidden', 'false');
}

  openButton.addEventListener('click', openModal);
  cancelButton?.addEventListener('click', closeModal);
  closeButton?.addEventListener('click', closeModal);
  backdrop?.addEventListener('click', closeModal);
  successCloseButton?.addEventListener('click', closeModal);


  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    const name = document
      .getElementById('fe-account-name')
      .value
      .trim();

    const email = document
      .getElementById('fe-account-email')
      .value
      .trim();

    submitButton.disabled = true;
    message.textContent = 'Creating account...';

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.error || 'Unable to create account.'
        );
      }

      message.textContent =
        'Account created successfully.';

      form.reset();

    } catch (error) {
      console.error(error);

      message.textContent =
        error.message || 'Unable to create account.';
    } finally {
      submitButton.disabled = false;
    }
  });
});